import { Action, createAction, props } from '@ngrx/store';
import { EntityDocument } from '../entity-document.model';
import { DocumentViewerConfiguration } from 'src/app/models/document-viewer-configuration.model';


export enum EntityDocumentActionTypes {
  LoadEntityDocument = '[Document] Load Entity Document',
  LoadEntityDocumentSuccess = '[Document] Load Entity Document Success',
  LoadEntityDocumentFail = '[Document] Load Entity Document Fail',

  LoadDocumentViewerConfiguration = '[Document] Load Document Viewre Configuration',
  LoadDocumentViewerConfigurationSuccess = '[Document] Load Document Viewre Configuration Success',
  LoadDocumentViewerConfigurationFail = '[Document] Load Document Viewre Configuration Fail',
}


export class loadDocuments implements Action {
  readonly type = EntityDocumentActionTypes.LoadEntityDocument;

  constructor(public keyword: string) { }
}

export class loadDocumentsSuccess implements Action {
  readonly type = EntityDocumentActionTypes.LoadEntityDocumentSuccess;

  constructor(public documents: EntityDocument) { }
}

export class loadDocumentsFailure implements Action {
  readonly type = EntityDocumentActionTypes.LoadEntityDocumentFail;
  constructor(public payload: string) { }
}

export class loadDocumentViewerConfiguration implements Action {
  readonly type = EntityDocumentActionTypes.LoadDocumentViewerConfiguration;

  constructor() { }
}

export class loadDocumentViewerConfigurationSuccess implements Action {
  readonly type = EntityDocumentActionTypes.LoadDocumentViewerConfigurationSuccess;

  constructor(public config: DocumentViewerConfiguration) { }
}

export class loadDocumentViewerConfigurationFail implements Action {
  readonly type = EntityDocumentActionTypes.LoadDocumentViewerConfigurationFail;

  constructor(public payload: string) { }
}

export type EntityDocumentActions = loadDocuments
  | loadDocumentsSuccess
  | loadDocumentsFailure
  | loadDocumentViewerConfiguration
  | loadDocumentViewerConfigurationSuccess
  | loadDocumentViewerConfigurationFail;
